import * as React from 'react'
import { FunctionComponent } from 'react'
import { IPivotItemProps, Pivot, PivotItem } from '@fluentui/react'
import { Route, Switch, useHistory } from 'react-router-dom'
import Users from './Settings/Users'
import Templates from './Settings/Templates'
import Implementation from './Settings/Implementation'

const items: IPivotItemProps[] = [
    {
        itemKey: 'users',
        headerText: 'Gebruikers',
    },
    {
        itemKey: 'templates',
        headerText: 'Standaarddocumenten',
    },
    {
        itemKey: 'implementation',
        headerText: 'Implementatie',
    },
]

const getItemRoute = (itemKey: string): string => {
    const item: IPivotItemProps = items.find(item => item.itemKey === itemKey)
    return `/settings/${item ? item.itemKey : ''}`
}

const Settings: FunctionComponent = () => {
    const history = useHistory()

    return (
        <>
            <Pivot linkSize="normal" linkFormat="tabs" onLinkClick={(item: PivotItem) => history.push(getItemRoute(item.props.itemKey))}>
                {items.map(item => (
                    <PivotItem key={item.itemKey} {...item} />
                ))}
            </Pivot>
            <Switch>
                <Route exact path="/settings" component={Users} />
                <Route exact path="/settings/users" component={Users} />
                <Route exact path="/settings/templates" component={Templates} />
                <Route exact path="/settings/implementation" component={Implementation} />
            </Switch>
        </>
    )
}

export default Settings
